import React, { useContext } from "react";
import { TranslationContext } from "./TranslationContext";

type TranslateProps = {
  path?: string;
  subs?: Record<string, unknown>;
  locale?: boolean;
};
const Translate: React.FC<TranslateProps> = ({ path, subs, locale }) => {
  const translation = useContext(TranslationContext);
  const html = locale ? translation.translateLocale() : translation.translate(path, subs);
  return <>{html}</>;
};

export default Translate;
